<template>
  <HrApprovalSent :image="image" />
</template>

<script>
import { getAsset } from 'ecx.saigon.ui.common';

export default {
  name: 'HrApprovalSentWidget',
  metaInfo: {
    title: 'HR Approval Sent |'
  },
  data() {
    return {
      image: undefined
    };
  },
  async mounted() {
    this.image = await getAsset(this.$Constants.HR_APPROVAL_SENT_PATH);
  },
  components: {
    HrApprovalSent: () => import('../../components/page/hr-approval-sent')
  }
};
</script>
